import Config from '../config/index';
import { isTopFace } from './face';

export function useNewVersion(url: string): boolean {
    let useStageCore: boolean = /useStageCore/.test(url);
    let useBad: boolean = /useBad/.test(url);
    let authCode: number = Config.get({
        moduleName: 'base',
        key: 'auth'
    });

    if (useStageCore) {
        return true;
    }

    if (useBad) {
        return false;
    }

    if (isTopFace()) {
        return authCode === 3;
    }

    return authCode === 1 || authCode === 3;
}
